// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","mapContainer":"App_mapContainer__DH78-","navbar":"App_navbar__gqftH","register":"App_register__t-4uX","centerButton":"App_centerButton__Vydm6"};